import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabulary} from '../schema';

/**
 * `addAttributeVocabulary` request params
 * (what is used to send to server)
 */

export type AddAttributeVocabularyRequestOptions = {
	name: string;
};

/**
 * `addAttributeVocabulary` request
 * (what gets sent to the server)
 */
export type AddAttributeVocabularyRequest = [
	AddAttributeVocabularyRequestOptions['name'],
];

/**
 * `addAttributeVocabulary` response
 * (what comes back from the server)
 */
export type AddAttributeVocabularyResponse =
	SuccessResponse<AddAttributeVocabularyResult>;

/**
 * `addAttributeVocabulary` result
 * (what is utilized from the server response)
 */
export type AddAttributeVocabularyResult = IAttributeVocabulary;

export const addAttributeVocabularyEndpoint = 'addAttributeVocabulary';

/**
 * Add attribute vocabularies list
 * @param fetchParams Fetch params

 */
export const addAttributeVocabulary = async ({
	name,
}: AddAttributeVocabularyRequestOptions): Promise<AddAttributeVocabularyResult> => {
	const client = NetxQueryClient();

	const requestParams: AddAttributeVocabularyRequest = [name];

	return client
		.post<AddAttributeVocabularyResponse>(
			addAttributeVocabularyEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default addAttributeVocabulary;
